import { Reveal } from "./Reveal";

const CLIENTS = [
  { name: "NH Hotels", font: "font-display", weight: 700, tracking: "0.08em" },
  { name: "Telefónica", font: "font-serif-italic", weight: 500, tracking: "0.02em" },
  { name: "EY", font: "font-display", weight: 800, tracking: "0.18em" },
  { name: "Gotor Comunicaciones", font: "font-display", weight: 400, tracking: "0.12em" },
];

export const Clients = () => {
  const loop = [...CLIENTS, ...CLIENTS, ...CLIENTS];
  return (
    <section
      className="relative py-16 md:py-24 bg-[var(--bb-bg)] border-y border-[var(--bb-border)]"
      data-testid="clients-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex items-center justify-between mb-10">
            <div className="mono-label">[ 02 / Cartera de Despliegues ]</div>
          </div>
        </Reveal>

        <div className="bb-marquee">
          <div className="bb-marquee-track">
            {loop.map((c, i) => (
              <ClientWordmark key={i} {...c} />
            ))}
          </div>
          <div className="bb-marquee-track" aria-hidden>
            {loop.map((c, i) => (
              <ClientWordmark key={`b-${i}`} {...c} />
            ))}
          </div>
        </div>

        <div className="mt-12 bb-divider" />
      </div>
    </section>
  );
};

const ClientWordmark = ({ name, font, weight, tracking }) => (
  <div
    className={`flex items-center whitespace-nowrap text-[var(--bb-text-2)] hover:text-[var(--bb-text)] transition-colors duration-500 ${font}`}
    style={{ fontWeight: weight, letterSpacing: tracking, fontSize: "clamp(26px, 3vw, 44px)" }}
    data-testid={`client-wordmark-${name.replace(/\s+/g, "-").toLowerCase()}`}
  >
    {name}
    <span
      className="mx-10 text-[var(--bb-copper)]"
      style={{ fontSize: "clamp(26px, 3vw, 44px)" }}
    >
      ✦
    </span>
  </div>
);
